"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _OrganisationNotifications = _interopRequireDefault(require("./OrganisationNotifications"));

var _UsedStorage = _interopRequireDefault(require("./UsedStorage"));

require("../styles/_actions.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function getTotalUsedPercent(current, total) {
  return current / total * 100;
}

function Actions(_ref) {
  var subPackage = _ref.subPackage,
      currentStorageUsage = _ref.currentStorageUsage,
      organisationId = _ref.organisationId,
      smallContainer = _ref.smallContainer;
  var total = subPackage ? subPackage.storageAllowance : 0;
  var usedPercent = total > 0 && currentStorageUsage ? getTotalUsedPercent(currentStorageUsage, total) : 0;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('actions', {
      'actions--small': smallContainer
    })
  }, _react.default.createElement(_UsedStorage.default, {
    currentStorageUsage: currentStorageUsage,
    totalStorageAllowance: total,
    usedPercent: usedPercent
  }), _react.default.createElement(_OrganisationNotifications.default, {
    id: organisationId,
    hasStorageError: usedPercent >= 75
  }));
}

var _default = (0, _react.memo)(Actions);

exports.default = _default;